import UploadResumeFloating from "../UploadResumeFloating";

const CLPUploadResumeFloating =() => {
    return (
        <UploadResumeFloating
            signupSource="clp_floating_resume"
        />
    );
};

export default CLPUploadResumeFloating;